import "core-js/modules/es6.array.find";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import refreshCustom from "./components/refreshCustom";
import moreCustom from "./components/moreCustom";
import logoImg1 from "./images/dianchi1.png";
import logoImg2 from "./images/dianchi2.png";
import logoImg3 from "./images/dianchi3.png";
import DistributionLog from "../devicedistribution/distributionLogSCLI";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import echarsView1 from "./echarsView1.vue";
import echarsViewSCLI from "./echarsViewSCLI.vue";
import echarsView3 from "./echarsView3.vue";
import axios from "axios";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import { get_device4g, get_left_data4g, get_qr_code, get_4g_broken_line, get_danti_view, get_qgl_data, get_qgl_broken_line, editPackSn, dldpset } from "@/api/chuku";
import { get_now_lnglat, get_downloadtoken, config_caiyang_pinglv, iotconfigset, web_issue_order, upup_firmware, progress_firmware, did_config_pass, get_firmware_info } from "@/api/jingxiaoshang";
import { commonReq } from "@/api/common";
import * as echarts from "echarts";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _ref;

    var now = new Date();
    var startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    var endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
    return _ref = {
      packSnBl: false,
      currentPage: 1,
      pageSize: 35,
      is_dingji: localStorage.getItem("is_dingji"),
      progress_text: "",
      password: null,
      passwordTypeIcon: "ios-eye",
      passwordType: "password",
      firmware_list: [],
      booleanValue: null,
      interval: null,
      mosState: null,
      shuaxin: null,
      timeoutId: null,
      NTC1: null,
      NTC2: null,
      NTC3: null,
      NTC4: null,
      NTC5: null,
      NTC6: null,
      NTC7: null,
      NTC8: null,
      NTC9: null,
      NTC10: null,
      alarm9_str: null,
      alarm10_str: null,
      alarm11_str: null,
      hj_wendu: null,
      moswendu: null,
      voltage_listRight: null,
      highestRight: null,
      minimumRight: null,
      yachaRight: null,
      averageRight: null,
      timestampsLine: null,
      dianliuLine: null,
      dianliuLine1: null,
      shengyurongliangLine: null,
      yachaLine: null,
      zongdianyaDataLine: null,
      fangdianDataLine: null,
      chongdianDataLine: null,
      intervalId: null,
      project_id: null,
      pack_sn: null,
      xunhuan_num: null,
      dianchichuan: null,
      mos_wendu: null,
      now_connect_status: null,
      huanjing_wendu: null,
      chongdianmos: null,
      junheng: null,
      fangdianmos: null
    }, _defineProperty(_ref, "now_connect_status", null), _defineProperty(_ref, "voltage", null), _defineProperty(_ref, "current", null), _defineProperty(_ref, "gonglv", null), _defineProperty(_ref, "manchong_capacity", null), _defineProperty(_ref, "remaining_capacity", null), _defineProperty(_ref, "sheji_capacity", null), _defineProperty(_ref, "battery_status", null), _defineProperty(_ref, "soc", null), _defineProperty(_ref, "total", null), _defineProperty(_ref, "rightAllData", null), _defineProperty(_ref, "hardware_verAll", {
      chan0: null,
      chan1: null
    }), _defineProperty(_ref, "hardware_ver", null), _defineProperty(_ref, "pack_sn", null), _defineProperty(_ref, "chans", null), _defineProperty(_ref, "chansAll", null), _defineProperty(_ref, "did", this.$route.query.did), _defineProperty(_ref, "bms_sn", null), _defineProperty(_ref, "bms_version", null), _defineProperty(_ref, "inner_ver", null), _defineProperty(_ref, "soft_ver", null), _defineProperty(_ref, "values", []), _defineProperty(_ref, "formValidate", {
      city: "",
      date: [startOfDay, endOfDay]
    }), _defineProperty(_ref, "gaugeChart", null), _defineProperty(_ref, "currDidTab", "0"), _defineProperty(_ref, "map", null), _defineProperty(_ref, "details_data", ["实时监测", "历史记录"]), _defineProperty(_ref, "items", []), _defineProperty(_ref, "imgSrc", require("./images/fengwo.png")), _defineProperty(_ref, "isClickable", true), _ref;
  },
  components: {
    ChartPie: ChartPie,
    ChartItemBar: ChartItemBar,
    ChartLineStackMul2: ChartLineStackMul2,
    DistributionLog: DistributionLog,
    AlermDes: AlermDes,
    Control: Control,
    Historyrouter: Historyrouter,
    echarsView1: echarsView1,
    echarsViewSCLI: echarsViewSCLI,
    echarsView3: echarsView3
  },
  methods: {
    ok1: function ok1(val) {},
    cancel: function cancel() {},
    change_tab2: function change_tab2(tab) {
      this.currDidTab = tab;

      if (this.$route.query.tabs) {
        this.$router.push({
          path: this.$route.path,
          // 保留当前路径
          query: _objectSpread({}, this.$route.query, {
            // 保留其他查询参数
            tabs: tab // 更新 tabs 参数

          })
        });
      }

      this.check_new();
    },
    //背景
    getDianchiStyle: function getDianchiStyle(value) {
      var maxValue = Math.max.apply(Math, _toConsumableArray(this.values));
      var minValue = Math.min.apply(Math, _toConsumableArray(this.values));

      if (value == maxValue) {
        return {
          backgroundImage: "url(".concat(logoImg3, ")") // 最大值背景

        };
      } else if (value == minValue) {
        return {
          backgroundImage: "url(".concat(logoImg2, ")") // 最小值背景

        };
      } else {
        return {
          backgroundImage: "url(".concat(logoImg1, ")") // 其他值背景

        };
      }
    },
    //折线图
    convertLine: function convertLine(value) {
      // this.mosState=value.
      this.timestampsLine = value.map(function (item) {
        return item.xuhao;
      });
      this.dianliuLine = value.map(function (item) {
        var dianliuValue = Number(item.current);
        return dianliuValue < 0 ? 0 : dianliuValue;
      });
      this.dianliuLine1 = value.map(function (item) {
        var dianliuValue = Number(item.current);
        return dianliuValue > 0 ? 0 : Math.abs(dianliuValue);
      });
      this.shengyurongliangLine = value.map(function (item) {
        return Math.round(item.remaining_capacity / item.manchong_capacity * 100);
      });
      this.yachaLine = value.map(function (item) {
        var voltageList = item.voltage_list;
        var maxVoltage = Math.max.apply(Math, _toConsumableArray(voltageList));
        var minVoltage = Math.min.apply(Math, _toConsumableArray(voltageList));
        return maxVoltage - minVoltage;
      });
      this.zongdianyaDataLine = value.map(function (item) {
        return Number(item.voltage).toFixed(2);
      });
      this.chongdianDataLine = value.map(function (item) {
        return Number(item.chongdianmos);
      });
      this.fangdianDataLine = value.map(function (item) {
        return Number(item.fangdianmos);
      });
      this.moswendu = value.map(function (item) {
        return Number(item.mos_wendu / 10);
      });
      this.hj_wendu = value.map(function (item) {
        return Number(item.hj_wendu / 10);
      });
      this.NTC1 = value.map(function (item) {
        return Number(item.wendu_list[0] / 10);
      });
      this.NTC2 = value.map(function (item) {
        return Number(item.wendu_list[1] / 10);
      });
      this.NTC3 = value.map(function (item) {
        return Number(item.wendu_list[2] / 10);
      });
      this.NTC4 = value.map(function (item) {
        return Number(item.wendu_list[3] / 10);
      });
      this.NTC5 = value.map(function (item) {
        return Number(item.wendu_list[4] / 10);
      });
      this.NTC6 = value.map(function (item) {
        return Number(item.wendu_list[5] / 10);
      });
      this.NTC7 = value.map(function (item) {
        return Number(item.wendu_list[6] / 10);
      });
      this.NTC8 = value.map(function (item) {
        return Number(item.wendu_list[7] / 10);
      });
      this.NTC9 = value.map(function (item) {
        return Number(item.wendu_list[8] / 10);
      });
      this.NTC10 = value.map(function (item) {
        return Number(item.wendu_list[9] / 10);
      });
      this.alarm9_str = value.map(function (item) {
        return item.alarm9_str;
      });
      this.alarm10_str = value.map(function (item) {
        return item.alarm10_str;
      });
      this.alarm11_str = value.map(function (item) {
        return item.alarm11_str;
      });
    },
    formatDate: function formatDate(dateString) {
      var date = new Date(dateString);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始

      var day = String(date.getDate()).padStart(2, "0");
      var hours = String(date.getHours()).padStart(2, "0");
      var minutes = String(date.getMinutes()).padStart(2, "0");
      var seconds = String(date.getSeconds()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    //查询
    queryData: function queryData() {
      var _this2 = this;

      this.formValidate.date[0] = this.formatDate(this.formValidate.date[0]);
      this.formValidate.date[1] = this.formatDate(this.formValidate.date[1]);
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1]
      }).then(function (res) {
        _this2.mosState = res.body.mos;

        _this2.convertLine(res.body.yunxing_trends);
      });
      this.echartsZhu();
    },
    echartsZhu: function echartsZhu() {
      var _this3 = this;

      get_danti_view({
        did: this.did,
        chan: this.formValidate.city
      }).then(function (res) {
        _this3.values = res.body.voltage_list;
        _this3.highestRight = res.body.highest;
        _this3.minimumRight = res.body.minimum;
        _this3.yachaRight = res.body.yacha;
        _this3.averageRight = res.body.average.toFixed(3);
      });
    },
    //复制信息
    copyToClipboard: function copyToClipboard(text) {
      var _this4 = this;

      navigator.clipboard.writeText(text).then(function () {
        _this4.$Message.success(_this4.$t("复制成功"));
      }).catch(function (err) {
        _this4.$Message.warning("复制失败");
      });
    },
    //导出
    exportHistory: function exportHistory() {
      // this.formValidate.date[0] =
      //   new Date(this.formValidate.date[0]).getTime() / 1000;
      // this.formValidate.date[1] =
      //   new Date(this.formValidate.date[1]).getTime() / 1000;
      // get_downloadtoken({ type: "1" }).then((res) => {
      //   if (res.result === 0) {
      //     let downloadtoken = res.body.downloadtoken;
      //     let country_code = localStorage.getItem("country_code");
      //     const baseUrl =
      //       country_code === "xciot-prod-cnsz"
      //         ? "https://bms-api.xcthings.com"
      //         : country_code === "xciot-prod-hk"
      //         ? "https://bms-hk-api.xcthings.com"
      //         : country_code === "xciot-prod-us2"
      //         ? "https://bms-us-api.xcthings.com"
      //         : "https://bms-eu-api.xcthings.com";
      //     axios
      //       .post(`https://bms-api.xcthings.com/index.php/admin/devicedetail/get_device_type`, {
      //         did: this.did,
      //       })
      //       .then((response) => {
      //         if (response.data.result === 0) {
      //           let lang =
      //             localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
      //           axios
      //             .post(
      //               `https://bms-api.xcthings.com/index.php/admin/device/history_daochu?lang=${lang}`,
      //               {
      //                 type: 1,
      //                 downloadtoken: downloadtoken,
      //                 did: this.did,
      //                 time_start: this.formValidate.date[0],
      //                 time_end: this.formValidate.date[1],
      //                 page: this.currentPage,
      //               }
      //             )
      //             .then((res) => {
      //               if (res.data.result !== 0) {
      //                 this.$Message.error(res.errorMsg);
      //               }
      //             });
      //           this.$Message.success(this.$t("导出成功"));
      //           this.$Modal.remove();
      //           const routeData = this.$router.push({
      //             path: "/deviceman/downloadlist",
      //           });
      //           window.open(routeData.href, "_self");
      //         }
      //       });
      //   } else {
      //     this.$Message.error(res.errorMsg);
      //   }
      // });
      this.$router.push({
        path: "/deviceman/distributionLog",
        query: {
          did: this.$route.query.did
        }
      });
    },
    tiaozhuanGj: function tiaozhuanGj() {
      this.currDidTab = "4";
    },
    refresh: function refresh() {
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, // "刷新频率"
          vm.$t("刷新频率")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(refreshCustom, {
            ref: "refreshCustom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              shuaxin: localStorage.getItem("shuaxin") || 60,
              parent_code: "0",
              parent_name: "无"
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.refreshCustom;
          obj.checkForm().then(function (res) {
            if (res) {
              vm.shuaxin = obj.formModel.refresh_value;
              vm.$Message.success("设置成功");
              vm.$Modal.remove();
              clearInterval(vm.dingshi);
              vm.dingshi = setInterval(vm.iotdatalastget, vm.shuaxin * 1000);
              localStorage.setItem("shuaxin", vm.shuaxin); //     vm.init()
            }
          }); // let _this = this;
          // let obj = this.$refs.refreshCustom;
          // obj.checkForm().then(res => {
          // if (res) {
          //   area_add({...obj.formModel}).then(res => {
          //   let msg=res.errorMsg;
          //   if (res.result === 0) {
          //     let msg=res.errorMsg;
          //     vm.$Message.success(msg);
          //     vm.$Modal.remove();
          //     vm.init()
          //   } else {
          //   vm.$Message.error(msg);
          //     _this.buttonLoading = false;
          //   }
          // });
          // } else {
          //     _this.buttonLoading = false;
          // }
          //  });
        }
      };
      this.$Modal.confirm(config);
    },
    //告警映射
    Alarms9Text: function Alarms9Text(alarmString) {
      var _this5 = this;

      // 每个位置对应的告警描述
      var alarms = ["低电量告警", "MOS高温告警", "环境低温告警", "环境高温告警", "放电低温告警", "充电低温告警", "放电高温告警", "充电高温告警", "预留", "电芯故障告警", "放电过流告警", "充电过流告警", "总压低压告警", "总压过压告警", "单体低压告警", "单体过压告警"];
      alarmString.split("").forEach(function (bit, index) {
        if (bit === "1") {
          _this5.items.push(alarms[index]);
        }
      });
    },
    Alarms10Text: function Alarms10Text(alarmString) {
      var _this6 = this;

      // 每个位置对应的告警描述
      var alarms = ["Fully（充满）", "环境低温保护", "环境高温保护", "MOS高温保护", "放电低温保护（电芯）", "充电低温保护（电芯）", "放电高温保护（电芯）", "充电高温保护（电芯）", "充电器高压", "短路", "放电过流保护", "充电过流保护", "总压过放保护", "总压过压保护", "单体过放保护", "单体过压保护"];
      alarmString.split("").forEach(function (bit, index) {
        if (bit === "1") {
          _this6.items.push(alarms[index]);
        }
      });
    },
    Alarms11Text: function Alarms11Text(alarmString) {
      var _this7 = this;

      // 每个位置对应的告警描述
      var alarms = ["", "", "", "", "", "", "", "", "加热膜故障", "限流故障", "放电过采样芯片故障流保护", "电芯故障", "", "温度传感器故障", "放电MOS故障", "充电MOS故障"];
      alarmString.split("").forEach(function (bit, index) {
        if (bit === "1") {
          _this7.items.push(alarms[index]);
        }
      });
    },
    //实时数据
    getleftData: function getleftData() {
      var _this8 = this;

      get_qgl_data({
        did: this.did,
        sdid: "SCLI"
      }).then(function (res) {
        _this8.bms_sn = res.body.bms_sn;
        _this8.pack_sn = res.body.pack_sn;
        _this8.hardware_verAll = res.body.hardware_ver;

        if (res.body.hardware_ver.chan1) {
          _this8.hardware_ver = res.body.hardware_ver.chan1;
        } else {
          _this8.hardware_ver = res.body.hardware_ver.chan0;
        } // this.items = res.body.data_protected_list.slice(0, 7);


        _this8.soc = res.body.soc;
        _this8.battery_status = res.body.battery_status;
        _this8.remaining_capacity = res.body.remaining_capacity;
        _this8.sheji_capacity = res.body.sheji_capacity;
        _this8.manchong_capacity = res.body.manchong_capacity;
        _this8.voltage = Number(res.body.voltage).toFixed(2);
        _this8.current = Number(res.body.current).toFixed(2);
        _this8.gonglv = Number(res.body.voltage * res.body.current).toFixed(2);
        _this8.now_connect_status = res.body.now_connect_status;
        _this8.junheng = res.body.junheng;
        _this8.dianchichuan = res.body.dianchichuan;
        _this8.mos_wendu = res.body.mos_wendu;
        _this8.huanjing_wendu = res.body.hj_wendu;
        _this8.xunhuan_num = res.body.xunhuan_num;
        _this8.pack_sn = res.body.pack_sn;
        _this8.project_id = res.body.project_id;
        _this8.bms_version = res.body.bms_version;
        _this8.inner_ver = res.body.inner_ver;
        _this8.soft_ver = res.body.soft_ver;

        _this8.Alarms9Text(res.body.alarm9_str);

        _this8.Alarms10Text(res.body.alarm10_str);

        _this8.Alarms11Text(res.body.alarm11_str);

        _this8.chongdianmos = res.body.alarm11_str[5];
        _this8.fangdianmos = res.body.alarm11_str[4];
        _this8.values = res.body.voltage_list.map(function (value) {
          return value / 1000;
        });
        _this8.highestRight = Math.max.apply(Math, _toConsumableArray(res.body.voltage_list)) / 1000;
        _this8.minimumRight = Math.min.apply(Math, _toConsumableArray(res.body.voltage_list)) / 1000;
        _this8.yachaRight = Math.round((_this8.highestRight - _this8.minimumRight) * 1000);
        _this8.averageRight = (res.body.voltage_list.reduce(function (sum, value) {
          return sum + value;
        }, 0) / res.body.voltage_list.length / 1000).toFixed(3);
      });
    },
    //获取历史
    getrightData: function getrightData(val) {
      var _this9 = this;

      get_qgl_broken_line({
        did: this.did,
        sdid: "SCLI",
        page: val
      }).then(function (res) {
        _this9.rightAllData = res.body.list;
        _this9.total = res.body.total;

        _this9.convertLine(res.body.list);
      });
    },
    handlePageChange: function handlePageChange(pageSize) {
      this.currentPage = pageSize;
      this.getrightData(pageSize);
    },
    handleChartClick: function handleChartClick(data) {
      var foundItem = this.rightAllData.find(function (item) {
        return item.xuhao === Number(data.data);
      });
      this.values = foundItem.voltage_list.map(function (value) {
        return value / 1000;
      });
      this.highestRight = Math.max.apply(Math, _toConsumableArray(foundItem.voltage_list)) / 1000;
      this.minimumRight = Math.min.apply(Math, _toConsumableArray(foundItem.voltage_list)) / 1000;
      this.yachaRight = Math.round((this.highestRight - this.minimumRight) * 1000);
      this.averageRight = (foundItem.voltage_list.reduce(function (sum, value) {
        return sum + value;
      }, 0) / foundItem.voltage_list.length / 1000).toFixed(3);
    },
    web_shuaxin: function web_shuaxin() {
      this.did = this.$route.query.did;

      if (this.$route.query.tabs) {
        this.currDidTab = this.$route.query.tabs;
      } // get_device4g({ did: this.did }).then((res) => {
      //   this.chansAll = res.body.chans;
      //   this.chans = res.body.chans[0];
      //   this.formValidate.city = res.body.chans[0];
      // get_left_data4g({ did: this.did, chan: this.chans, web_time: 0 }).then(
      //   (res) => {
      //     this.sn = res.body.sn;
      //     this.pack_sn = res.body.pack_sn;
      //     this.hardware_verAll = res.body.hardware_ver;
      //     if (res.body.hardware_ver.chan1) {
      //       this.hardware_ver = res.body.hardware_ver.chan1;
      //     } else {
      //       this.hardware_ver = res.body.hardware_ver.chan0;
      //     }
      //     this.items = res.body.data_protected_list.slice(0, 7);
      //     console.log("左侧数据", this.items);
      //     this.soc = res.body.soc;
      //     this.battery_status = res.body.battery_status;
      //     this.remaining_capacity = res.body.remaining_capacity;
      //     this.manchong_capacity = res.body.manchong_capacity;
      //     this.zongdianya = res.body.zongdianya;
      //     this.dianliu = res.body.dianliu;
      //     this.gonglv = res.body.gonglv;
      //     this.now_connect_status = res.body.now_connect_status;
      //     this.chongdianmos = res.body.chongdianmos;
      //     this.fangdianmos = res.body.fangdianmos;
      //     this.junheng = res.body.junheng;
      //     this.dianchichuan = res.body.dianchichuan;
      //     this.mos_wendu = res.body.mos_wendu;
      //     this.huanjing_wendu = res.body.huanjing_wendu;
      //     this.xunhuan_num = res.body.xunhuan_num;
      //     this.pack_sn = res.body.pack_sn;
      //     this.project_id = res.body.project_id;
      //     this.out_ver = res.body.out_ver;
      //     this.inner_ver = res.body.inner_ver;
      //     this.soft_ver = res.body.soft_ver;
      //   }
      // );
      // get_danti_view({ did: this.did, chan: this.chans }).then((res) => {
      //   this.values = res.body.voltage_list;
      //   this.highestRight = res.body.highest;
      //   this.minimumRight = res.body.minimum;
      //   this.yachaRight = res.body.yacha;
      //   this.averageRight = res.body.average;
      // });
      // console.log(
      //   "this.formValidate.date[0]",
      //   this.formatDate(this.formValidate.date[0])
      // );
      // get_4g_broken_line({
      //   did: this.did,
      //   chan: this.formValidate.city,
      //   start_time: this.formatDate(this.formValidate.date[0]),
      //   end_time: this.formatDate(this.formValidate.date[1]),
      // }).then((res) => {
      //   this.mosState = res.body.mos;
      //   this.convertLine(res.body.yunxing_trends);
      // });
      // });


      this.getleftData();
      this.getrightData(1);
    },
    // startTimer() {
    //   this.shuaxin = localStorage.getItem("shuaxin") || 60;
    //   let shuaxintime = this.shuaxin * 1000;
    //   this.clearTimer();
    //   this.timeoutId = setInterval(() => {
    //     this.web_shuaxin();
    //   }, shuaxintime);
    // },
    clearTimer: function clearTimer() {
      if (this.timeoutId) {
        clearInterval(this.timeoutId);
        this.timeoutId = null;
      }
    },
    savepassword: function savepassword() {
      var _this10 = this;

      did_config_pass({
        pass: this.password,
        did: this.did
      }).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this10.$Message.success(msg);
        } else {
          _this10.$Message.error(msg);
        }
      });
    },
    swicthPassword: function swicthPassword() {
      if (this.passwordTypeIcon === "ios-eye") {
        this.passwordTypeIcon = "ios-eye-off";
        this.passwordType = "text";
      } else if (this.passwordTypeIcon === "ios-eye-off") {
        this.passwordTypeIcon = "ios-eye";
        this.passwordType = "password";
      }
    },
    uploadFirmware: function uploadFirmware(dp_chan) {
      var did = this.did;
      this.result_firmware = [];
      var vm = this;
      var config = {
        title: "升级",
        loading: true,
        content: "您确定要升级通道" + dp_chan + "的固件吗？",
        onOk: function onOk() {
          var _this = this;

          upup_firmware({
            did: did,
            dp_chan: dp_chan
          }).then(function (res) {
            if (res.result === 0) {
              _this.$Message.success(res.errorMsg);

              vm.$Modal.remove();
              _this.buttonLoading = false; // this.getFirmwareInfo()
              //拉取进度

              vm.firmware_list[dp_chan].is_jindu = 1;
              vm.firmware_list[dp_chan].is_shengji = 0; // vm.progress_dingshi = setInterval(vm.progress, 5000);

              vm.progress_dingshi = setInterval(function () {
                vm.progress(dp_chan);
              }, 3000);
            } else {
              _this.$Message.error(res.errorMsg);

              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    //检测新的固件版本
    check_new: function check_new(chan_id) {
      var _this11 = this;

      //alert(123)
      //get_firmware_info
      // console.log("aaa",this.did)
      //获取设备信息
      get_firmware_info({
        did: this.did
      }).then(function (res) {
        _this11.tableLoading = false;
        _this11.tableDataList = [];

        if (res.result === 0) {
          //this.details_data = res.body;
          // if (res.body.firmware == "") {
          //   this.$Message.error("暂无可更新固件");
          // }
          if (res.body.firmware && res.body.firmware.length > 0) {
            //this.is_update=res.body.firmware[0].is_update
            if (_this11.is_update === 0) {//  this.$Message.info("已经是最新版本")
            } else {} //  this.$Message.success("检测出可升级的固件")
              //console.log("res.body.firmware.firmware_ver.multi_rom",res.body.firmware.firmware_ver.multi_rom)


            _this11.firmware_list = res.body.firmware;

            if (chan_id == 0 || chan_id > 0) {
              _this11.$Message.success(_this11.$t("检测成功"));
            }
          } else {
            _this11.is_update = 0; //  this.$Message.error("暂无可升级的固件")
          }
        } else {
          _this11.tableDataList = [];
          _this11.getPageTotal = 0;

          _this11.$Message.error(res.errorMsg);
        }
      });
    },
    progress: function progress(dp_chan) {
      var _this12 = this;

      var did = this.did;
      progress_firmware({
        did: did,
        dp_chan: dp_chan
      }).then(function (res) {
        if (res.result === 0) {
          if (res.body.jindu == 100) {
            setTimeout(function () {
              _this12.check_new();
            }, 15000); // 15000 毫秒 = 15 秒
          } // //拉取进度
          //this.is_jindu = 1;


          _this12.firmware_list[dp_chan].is_jindu = 1;

          if (res.body.jindu == 100) {
            clearInterval(_this12.progress_dingshi);
          }

          _this12.firmware_list[dp_chan].progress_percent = res.body.jindu;
          _this12.firmware_list[dp_chan].progress_text = res.body.ext_code;

          if (_this12.result_firmware.length >= 6) {
            var last = _this12.result_firmware.length - 1;

            if (_this12.result_firmware[last] == _this12.result_firmware[last - 1] && _this12.result_firmware[last] == _this12.result_firmware[last - 2] && _this12.result_firmware[last] == _this12.result_firmware[last - 3] && _this12.result_firmware[last] == _this12.result_firmware[last - 4] && _this12.result_firmware[last] == _this12.result_firmware[last - 5] && _this12.result_firmware[last] == _this12.result_firmware[last - 6]) {
              clearInterval(_this12.progress_dingshi); //this.$Message.error("固件升级超时，升级失败")

              _this12.$Notice.open({
                title: "升级通知",
                desc: "通道" + dp_chan + "固件升级超时，升级失败",
                duration: 0
              });

              _this12.check_new();
            }
          }

          _this12.result_firmware.push(res.body.jindu);
        } else {
          _this12.$Message.error(res.errorMsg); //this.is_jindu = 0;


          _this12.firmware_list[dp_chan].is_jindu = 0; //this.is_shengji = 1

          _this12.firmware_list[dp_chan].is_shengji = 1; //this.progress_percent = 0;

          _this12.firmware_list[dp_chan].progress_percent = 0; //this.progress_text = "";

          _this12.firmware_list[dp_chan].progress_text = "";
          clearInterval(_this12.progress_dingshi);
        } //这里
        // if (this.progress_percent < 100) {
        //   this.progress_percent += 10;
        // }

      });
    },
    handleBlur: function handleBlur() {
      var _this13 = this;

      var dpcmd = {
        dpcmd: {
          t: 0,
          did: this.did,
          sdid: "",
          seq: 1,
          timestamp: parseInt(new Date().getTime() / 1000),
          ans: false,
          dpv_count: 1,
          dps: [{
            dp_id: 2318,
            dp_type: 2,
            dp_chan: 0,
            val_str: this.pack_sn
          }]
        }
      };
      dldpset(dpcmd).then(function (res) {
        if (res.result == 0) {
          _this13.$Message.success(_this13.$t("修改成功"));
        } else {
          _this13.$Message.error("修改失败");
        }
      });
    }
  },
  mounted: function mounted() {
    var _this14 = this;

    this.web_shuaxin(); // this.startTimer();
    // this.initializeTimer();

    this.intervalId = setInterval(function () {
      _this14.items = [];

      _this14.getleftData();
    }, 6000);
    editPackSn({
      did: this.$route.query.did,
      dpid: 2318
    }).then(function (res) {
      console.log("是否支持", res);

      if (res.body.is_support == 1) {
        _this14.packSnBl = true;
      } else {
        _this14.packSnBl = false;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.intervalId);
  },
  destroyed: function destroyed() {}
};